var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppInstall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 25,
    fill: "#3478F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 19C33.866 19 37 22.134 37 26V26.0283C39.2499 26.2771 41 28.1838 41 30.5C41 32.9853 38.9853 35 36.5 35H33V33.5H36.5C38.1569 33.5 39.5 32.1569 39.5 30.5C39.5 28.9572 38.3337 27.6852 36.835 27.5195L35.5 27.3721V26C35.5 22.9624 33.0376 20.5 30 20.5C27.4702 20.5 25.3359 22.2097 24.6963 24.54L24.46 25.4023L23.5898 25.6045C21.8185 26.0162 20.5 27.6059 20.5 29.5C20.5 31.7091 22.2909 33.5 24.5 33.5H27V35H24.5C21.4624 35 19 32.5376 19 29.5C19 26.8925 20.8147 24.7096 23.25 24.1436C24.0636 21.1787 26.7768 19 30 19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29V40",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37.5L30 40.5L27 37.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppInstall);
export default __webpack_public_path__ + "static/media/AppInstall.d955cfc0befcdeaf8a06c300660306eb.svg";
export { ForwardRef as ReactComponent };